import { FC, memo } from 'react'

import styles from '../Dialog.module.scss'

type Props = {
  name: string
}

export const MessageName: FC<Props> = memo(function MessageName({
  name,
}: Props) {
  return <div className={styles.messageName}>{name}</div>
})
